import RouteTemplate from 'ember-route-template';

import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import LocationDetailDetail from 'rise-ui/components/location/detail/detail.gjs';
import LocationDetailRelatedLocations from 'rise-ui/components/location/detail/related-locations.gjs';
import LocationDetailRelatedRecords from 'rise-ui/components/location/detail/related-records.gjs';
import string from 'rise-ui/helpers/string.js';

export default RouteTemplate(class LocationDetailTemplate extends Component {
  <template>
    {{pageTitle (concat "Location " @model.location.id)}}
    {{pageTitle @model.location.name}}

    <div class="id-location-detail">
      <h3 class="c-page-title qa-page-title">{{string "location-heading"}}</h3>
      <h3 class="id-location-detail__title qa-location-name">{{@model.location.name}}</h3>
      <div class="qa-location-description">{{@model.location.description}}</div>
      <LocationDetailDetail
        @location={{@model.location}}
      />
      <LocationDetailRelatedLocations
        @location={{@model.location}}
      />
      <LocationDetailRelatedRecords
        @location={{@model.location}}
      />
    </div>
    {{outlet}}
  </template>
});
